import React from 'react';
import { useRouter } from 'next/router';
import { mediaSortings, mediaSortingDefault } from '../../config';
import { groupByTag, getInitialProps } from '../Filter/utils';
import Filter from '../Filter';
import useStores from '../../utils/useStores';

const tags = ['Format:Prüflabore'];

const types = ['unternehmen'];

const Prueflabore = () => {
  const router = useRouter();
  const { uiStore, dataStore } = useStores();
  const [data, setData] = React.useState([]);
  const [filters, setFilters] = React.useState([]);
  const [query, setQuery] = React.useState('');

  React.useEffect(() => {
    const loadData = getInitialProps(tags, types);
    const initializeData = async () => {
      const { filters, data, query } = await loadData({
        uiStore,
        dataStore,
        query: router.query,
      });
      setQuery(query);
      setFilters(filters);
      setData(data);
    };
    initializeData();
  }, []);

  return (
    <Filter
      noMargin
      context={uiStore.context}
      title=""
      noTitle
      titleProps={{
        variant: 'h2',
        'data-underline': true,
        'data-underline-less-spacing': true,
        color: 'inherit',
      }}
      searchPlaceholder="Prüflabore durchsuchen"
      data={data}
      query={query}
      filters={filters}
      // filterTags={['Format']}
      // groupBy={groupByTag('Format:')}
      sortings={mediaSortings}
      sortingDefault={mediaSortingDefault}
    />
  );
};

export default Prueflabore;
